import moment from "moment";

export const normalizeSubCompanyIdForApi = subCompanyId =>
    subCompanyId && subCompanyId !== "all" ? subCompanyId : undefined;

export const normalizeCompanyIdForApi = companyId =>
    companyId && companyId !== "all" ? companyId : undefined;

/**
 * Shared filter body for payment-transaction-log list, Excel export, and calculations.
 */
export const buildPaymentTransactionLogFilterParams = ({
    companyId,
    selectedDateRange,
    isDateRangeChecked,
    isPeriodChecked,
    selectedPeriod,
    selectedTransactionType,
    selectedSubType,
    selectedHasWalletTransaction,
    workType,
    searchText,
    selectedInvoiceStatus,
    selectedProviderCompany,
    selectedCreditMode,
    activeTab,
    invoiceId
}) => {
    const useDateRange =
        (isDateRangeChecked || (isPeriodChecked && !selectedPeriod)) &&
        selectedDateRange?.length === 2 &&
        selectedDateRange[0] &&
        selectedDateRange[1];

    return {
        ...(companyId ? {companyId} : {}),
        startDate: useDateRange ? moment(selectedDateRange[0]).format("YYYY-MM-DD") : undefined,
        endDate: useDateRange ? moment(selectedDateRange[1]).format("YYYY-MM-DD") : undefined,
        paymentPeriodId: isPeriodChecked && selectedPeriod ? selectedPeriod : undefined,
        transactionType: selectedTransactionType || [],
        processedSubType: selectedSubType || [],
        hasWalletTransaction:
            selectedHasWalletTransaction === "all"
                ? undefined
                : selectedHasWalletTransaction === "true",
        workType: workType === "all" ? undefined : workType,
        searchText: searchText || undefined,
        invoiceStatus: selectedInvoiceStatus === "all" ? undefined : selectedInvoiceStatus,
        providerCompanies:
            !selectedProviderCompany || selectedProviderCompany === "all"
                ? undefined
                : [selectedProviderCompany],
        creditMode: selectedCreditMode || [],
        invoiceId: invoiceId || undefined,
        groupType:
            activeTab === "courierTotalDetail"
                ? "courier"
                : activeTab === "subCompanyTotalDetail"
                ? "subCompany"
                : undefined
    };
};
